export default {
  program: {
    programName: "",
    code: "",
    id: "",
    questionnaireUUID: "",
  },
  additionalOrderEntryQuestions: '{"resourceType":"Questionnaire"}',
  testSectionId: "",
};
